import { c as _c } from "react/compiler-runtime";
import { useQueries } from '@tanstack/react-query';
import type { FormattedAddress } from '../../../../../onboarding-business-insight.types';
import GoogleMapsLoader from './google-maps-loader';
type Coordinates = {
  latitude: number;
  longitude: number;
};
const geocode = async (address: string): Promise<Coordinates | null> => {
  try {
    await GoogleMapsLoader.importLibrary('geocoding');
    const {
      results
    } = await new google.maps.Geocoder().geocode({
      address
    });
    const location = results[0]?.geometry.location;
    return location ? {
      latitude: location.lat(),
      longitude: location.lng()
    } : null;
  } catch {
    return null;
  }
};

/** Fills in the coordinates the API left out, for the addresses complete enough to find. */
const useAddressCoordinates = addresses => {
  const $ = _c(9);
  let t0;
  if ($[0] !== addresses) {
    t0 = addresses.map(_temp);
    $[0] = addresses;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      queries: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const queries = useQueries(t1);
  let t2;
  if ($[4] !== addresses || $[5] !== queries) {
    let t3;
    if ($[7] !== queries) {
      t3 = (address_0, index) => ({
        ...address_0,
        ...queries[index].data
      });
      $[7] = queries;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = addresses.map(t3);
    $[4] = addresses;
    $[5] = queries;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useAddressCoordinates;
function _temp(address) {
  const fields = [address.addressLine1, address.city, address.state, address.postalCode];
  return {
    queryKey: ["business-insights", "geocode", ...fields],
    queryFn: () => geocode(fields.join(", ")),
    enabled: !(address.latitude && address.longitude) && fields.every(Boolean),
    staleTime: Number.POSITIVE_INFINITY
  };
}